export const tokens = {
    width: 280,
    gap: 40,
    safetyPadding: 4,
    stickyTop: 95,
};
